/**
 * @license Givaudan
 * @author Ayoub MHAMDI
 */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { IconComponent } from '@banyan/modules/standalone/icon/icon.component';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatIconModule, IconComponent],
  standalone: true,
})
export class CardComponent {
  @Input() text = '';
  @Input() icon = '';
  @Input() state: 'default' | 'selected' = 'default';
  @Output() cardClicked: EventEmitter<void> = new EventEmitter<void>();

  onCardClick(): void {
    this.cardClicked.emit();
  }
}
